<template>
  <v-autocomplete
    v-bind="$attrs"
    ref="field"
    v-model="localValue"
    :clearable="clearable && !$attrs.readonly && $attrs.readonly !== ''"
    :items="itemList"
    :loading="loading"
    no-filter
    :search-input.sync="match"
    @change="(v) => $emit('change', v)"
    @focus="(e) => e.target.click()"
  />
</template>

<script>
import { debounce } from 'debounce'
export default {
  name: 'TownField',
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    provinceId: {
      type: String,
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      match: '',
      itemList: [],
      loading: false,
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    localValue() {
      this.fetch()
    },
    match() {
      this.fetch()
    },
    provinceId() {
      this.fetch()
    },
  },
  created() {
    this.fetch = debounce(function () {
      if (this.localValue !== this.$refs.field.lazyValue)
        this.$refs.field.lazyValue = this.localValue

      let params = { set: false }
      if (this.localValue) {
        params._id = this.localValue
      } else {
        if (this.match) params.match = this.match
        if (this.provinceId) params.provinceId = this.provinceId
      }
      this.loading = true
      this.$store
        .dispatch('towns/fetchSelectList', params)
        .then((list) => {
          this.itemList = []
          list.forEach((item) => {
            this.itemList.push(item)
          })
          if (!this.itemList.some((item) => item.value === this.localValue))
            this.localValue = ''
        })
        .finally(() => {
          this.loading = false
        })
    }, 700)
    this.fetch()
  },
  methods: {
    fetch() {},
  },
}
</script>
